// Shared site config. Update these in one place.
export const CONTACT_EMAIL = "contact@domichron.com";
export const LINKEDIN_URL = "https://www.linkedin.com/company/domichron/";
export const DOMESCRIBE_URL = "https://domescribe.ai/";
